/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyOAuthStatus } from '../../models/calendly-o-auth-status';

export interface GetCalendlyOAuthStatus$Params {
}

export function getCalendlyOAuthStatus(http: HttpClient, rootUrl: string, params?: GetCalendlyOAuthStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyOAuthStatus>> {
  const rb = new RequestBuilder(rootUrl, getCalendlyOAuthStatus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyOAuthStatus>;
    })
  );
}

getCalendlyOAuthStatus.PATH = '/v1/api/ui/calendly-demo/oauth/status';
